// local storage variable names
// they are used to store user session date ion local storage
export const hncTokenStr = "hnc-user-token";
export const hncStoredEmailStr = "hnc-user-stored-email";
export const hncUserSession = "hnc-user-session";
export const prevPathStorageKey = "hnc-prev-path";
export const hncColorTheme = "hnc-color-theme"; // create key that will be used to store theme in localstorage
